import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { BrandLockup } from "./Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Servizi", href: "#servizi", testid: "nav-link-servizi" },
  { label: "Lavori", href: "#galleria", testid: "nav-link-galleria" },
  { label: "Chi Siamo", href: "#chi-siamo", testid: "nav-link-chi-siamo" },
  { label: "Il Metodo", href: "#metodo", testid: "nav-link-metodo" },
  { label: "Contatti", href: "#contatti", testid: "nav-link-contatti" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed z-50 top-4 left-1/2 -translate-x-1/2 w-[94%] max-w-7xl backdrop-blur-xl bg-[#13151A]/80 border rounded-full px-4 sm:px-6 py-3 flex items-center justify-between transition-[border-color,box-shadow] duration-500 ${
        scrolled ? "border-[#D97736]/30 shadow-[0_8px_40px_rgba(217,119,54,0.12)]" : "border-white/10"
      }`}
    >
      <a
        href="#top"
        data-testid="header-brand-logo"
        onClick={(e) => {
          e.preventDefault();
          scrollToId("#top");
        }}
        aria-label="MERLO coperture - home"
      >
        <BrandLockup />
      </a>

      <nav className="hidden lg:flex items-center gap-7">
        {LINKS.map((l) => (
          <button
            key={l.href}
            data-testid={l.testid}
            onClick={() => scrollToId(l.href)}
            className="font-outfit text-sm text-[#9CA3AF] hover:text-[#F3F4F6] transition-colors duration-300 tracking-wide"
          >
            {l.label}
          </button>
        ))}
      </nav>

      <div className="flex items-center gap-2 sm:gap-3">
        <a
          href="tel:+393517479343"
          data-testid="nav-phone-call-button"
          className="hidden sm:flex items-center gap-2 font-mono text-xs text-[#F3F4F6] border border-white/10 hover:border-[#D97736]/50 rounded-full px-4 py-2 transition-colors duration-300"
        >
          <span className="w-2 h-2 rounded-full bg-[#D97736] animate-pulse-dot" aria-hidden="true" />
          <Phone size={13} strokeWidth={2.2} />
          <span className="hidden md:inline">+39 351 747 9343</span>
        </a>
        <button
          data-testid="nav-quote-cta-button"
          onClick={() => scrollToId("#preventivo")}
          className="group flex items-center gap-2 bg-[#D97736] hover:bg-[#E88D52] text-[#0B0C0E] font-outfit font-semibold text-sm rounded-full px-4 sm:px-5 py-2 transition-colors duration-300"
        >
          Preventivo
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5" />
        </button>
      </div>
    </motion.header>
  );
}
